import { useContactSupportIntercom } from './support-intercom';
import type { ContactSupportFn } from './support-types';

export * from './support-types';

/**
 * Returns a function that opens the contact support chat widget.
 * Depending on the feature flag, it will open either Front or Helpscout.
 */
export function useContactSupport(): ContactSupportFn {
    const openIntercom = useContactSupportIntercom();
    return openIntercom;
}
